import { render, staticRenderFns } from "./EmployeeWorkforceHistoryContent.vue?vue&type=template&id=0c13ba2e&scoped=true&"
import script from "./EmployeeWorkforceHistoryContent.vue?vue&type=script&lang=js&"
export * from "./EmployeeWorkforceHistoryContent.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeWorkforceHistoryContent.vue?vue&type=style&index=0&id=0c13ba2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c13ba2e",
  null
  
)

export default component.exports